var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 36,
    viewBox: "0 0 56 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 35.2,
    rx: 3,
    fill: "#969EB1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5416 22.1182H23.1381L24.6403 12.8864H27.044L25.5416 22.1182ZM21.1161 12.8864L18.8247 19.2361L18.5536 17.8688L18.5538 17.8692L17.7451 13.7176C17.7451 13.7176 17.6473 12.8864 16.6049 12.8864H12.8168L12.7723 13.0427C12.7723 13.0427 13.9308 13.2837 15.2865 14.0979L17.3746 22.1184H19.8789L23.7029 12.8864H21.1161ZM40.021 22.1182H42.2279L40.3037 12.8861H38.3716C37.4794 12.8861 37.2621 13.5741 37.2621 13.5741L33.6774 22.1182H36.1829L36.684 20.7469H39.7394L40.021 22.1182ZM37.3762 18.8526L38.6391 15.3978L39.3495 18.8526H37.3762ZM33.8654 15.1064L34.2084 13.124C34.2084 13.124 33.15 12.7214 32.0466 12.7214C30.8539 12.7214 28.0214 13.2427 28.0214 15.7776C28.0214 18.1626 31.3458 18.1923 31.3458 19.445C31.3458 20.6978 28.3639 20.4733 27.3799 19.6833L27.0225 21.7562C27.0225 21.7562 28.0958 22.2775 29.7355 22.2775C31.3757 22.2775 33.8501 21.4282 33.8501 19.1168C33.8501 16.7165 30.4958 16.493 30.4958 15.4494C30.4961 14.4056 32.8368 14.5397 33.8654 15.1064Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5537 17.8686L17.745 13.717C17.745 13.717 17.6472 12.8857 16.6049 12.8857H12.8168L12.7723 13.0421C12.7723 13.0421 14.593 13.4194 16.3394 14.8331C18.0092 16.1844 18.5537 17.8686 18.5537 17.8686Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.6cbdb051c0513afb480446f6e58e2386.svg";
export { ForwardRef as ReactComponent };